import { overParseJson, checkAttendantAndFetch } from '../utils/requestUtils';

const CREATE_LABELS_URL = 'https://afiliados.uol.com.br/addLabelToAffiliated.html';
const REMOVE_LABEL_URL = 'https://afiliados.uol.com.br/deleteLabel.html';
const HTTP_ERROR = 'HTTP_ERROR';

class LabelsApi {
  static buildLabelPayload(label) {
    return {
      desLabel: label.label,
      idtUserSupplierLabelList: [label.value],
    };
  }

  static async createLabel(desLabel) {
    try {
      const fetchResponse = await checkAttendantAndFetch(CREATE_LABELS_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          // eslint-disable-next-line quote-props
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          labelToInsert: desLabel,
        }),
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);
      this.validateResponse(fetchResponse, data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async deleteLabel(label) {
    const payload = this.buildLabelPayload(label);
    try {
      const fetchResponse = await checkAttendantAndFetch(REMOVE_LABEL_URL, {
        method: 'POST',
        credentials: 'same-origin',
        // eslint-disable-next-line quote-props
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          labelRequest: payload,
        }),
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static validateResponse(fetchResponse, data) {
    if (fetchResponse.status !== 200) {
      const responseError = new Error(data.error || 'Internal server error');
      responseError.code = HTTP_ERROR;
      responseError.status = fetchResponse.status;
      throw responseError;
    } else if (data.serviceStatus !== 'SUCCESS') {
      const validationError = new Error(data.message || 'Erro desconhecido');
      validationError.code = data.codeMessage || 'UNKNOWN_ERROR';
      validationError.status = data.serviceStatus;
      throw validationError;
    }
  }
}

export default LabelsApi;
